import { IDaySchedule } from "@services/getMinerList";
import { useContext, useEffect, useState } from "react";
import { IPlanCreatorProps } from "./PlanCreator.props";
import { PlanCreatorContext } from "./PlanCreatorContext";
import { useAuth } from "@utils/hooks/useAuth";

export const usePlanCreatorControl = (props: IPlanCreatorProps) => {

  const auth = useAuth();

  const {
    plan,
    reset,
    disabled,
    planName,
    setPlanName,
    onSavePlan
  } = useContext(PlanCreatorContext);

  const [days, setDays] = useState<IDaySchedule[]>(plan?.schedule || []);

  const onChangePlanName = (e: React.FormEvent<HTMLInputElement>) => {
    setPlanName(e.currentTarget.value);
  };

  useEffect(() => {
    if (props.closeOnEsc) {
      document.addEventListener("keydown", onKeyDown);
      return () => {
        document.removeEventListener("keydown", onKeyDown);
      }
    }
    function onKeyDown(e: KeyboardEvent) {
      if (e.key === "Escape") {
        props.onCancelEdit?.()
      }
    }
  }, []);

  useEffect(() => {
    setDays(plan?.schedule || []);
  }, [plan?.schedule]);

  useEffect(() => {
    if (reset) {
      setDays(plan?.schedule || []);
    }
  }, [reset]);

  function onSaveClicked(e: React.MouseEvent<HTMLButtonElement>) {
    e.stopPropagation();
    e.preventDefault();
    onSavePlan();
  }

  return {
    plan,
    isAdmin: auth.isAdmin,
    days,
    planName,
    reset,
    disabled,
    onChangePlanName,
    onSaveClicked,
  };
};
